<template>
  <b-modal
    :id="itemVariant._id"
    :ok-title="$t('Variant.okTitle')"
    @ok="buildAndAddToCart(itemVariant)"
    ok-variant="danger"
    :cancel-title="$t('Variant.cancelTitle')"
    hide-header
    centered
  >
    <b-row class="text-center">
      <b-col>
        <b-img :src="menuitem.image" fluid />
      </b-col>
    </b-row>
    <b-row class="text-left" style="padding-top: 0.5rem;">
      <b-col>
        <h5>{{itemName}}</h5>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-badge style="margin-right: 0.25em;" v-for="iflt in itemFilters" :key="iflt">{{iflt}}</b-badge>
      </b-col>
    </b-row>
    <b-form-group v-show="showThis.styles" :label="$t('Variant.style')" class="text-left">
      <b-form-radio-group v-model="styleSelected" :options="styleOptions" name="stylesInline"></b-form-radio-group>
    </b-form-group>
    <b-form-group v-show="showThis.extras" :label="$t('Variant.extras')" class="text-left">
      <b-form-checkbox-group
        stacked
        name="extras"
        v-model="extrasSelected"
        :options="extrasOptions"
      ></b-form-checkbox-group>
    </b-form-group>
    <div class="text-right">
      <h4>{{ $t('Variant.price') }}: {{itemPrice.toFixed(2)}} {{menuitem.currency}}</h4>
    </div>
  </b-modal>
</template>

<script>
/* CONTROLLER */
import { mapActions } from 'vuex'

export default {
  props: ['itemVariant', 'menuitem', 'filterTags'],
  name: 'Variant',
  data () {
    return {
      styleSelected: null,
      styleOptions: [],
      extrasSelected: [],
      extrasOptions: [],
      showThis: {
        styles: false,
        extras: false
      }
    }
  },
  mounted () {
    this.buildVariant()
  },
  methods: {
    buildVariant () {
      // build style radio buttons
      this.menuitem.styles.forEach((style, i) => {
        let newStyle = { text: style.name, value: style.name }
        this.styleOptions.push(newStyle)
        if (i === 0) this.styleSelected = style.name // auto-select first style
      })

      // build extras checkboxes
      this.menuitem.extras.forEach(extra => {
        let newExtra = {
          text: extra.name + ' (+' + extra.price.toFixed(2) + ')',
          value: extra.name
        }
        this.extrasOptions.push(newExtra)
      })
    },
    ...mapActions(['addToCart']),
    buildAndAddToCart (itemVariant) {
      // build object and send to store
      let sendObject = {
        _id: this.itemVariant._id,
        variant: this.itemVariant.name,
        price: this.itemPrice,
        name: this.menuitem.name,
        currency: this.menuitem.currency,
        category: this.menuitem.category,
        extras: this.extrasSelected.sort(),
        style: this.styleSelected
      }
      this.addToCart(sendObject)
    }
  },
  computed: {
    itemName: function () {
      return this.menuitem.name + ' ' + this.itemVariant.name
    },
    itemPrice: function () {
      let extrasPrice = 0
      this.extrasSelected.forEach(extra => {
        this.menuitem.extras.forEach(el => {
          if (extra === el.name) {
            extrasPrice += el.price
          }
        })
      })
      return this.itemVariant.price + extrasPrice
    },
    itemFilters () {
      let itemFT = []
      if (this.filterTags) {
        this.filterTags.forEach(ft => {
          if (this.menuitem.tags.includes(ft.value)) itemFT.push(ft.text)
        })
      }
      return itemFT
    }
  },
  watch: {
    styleOptions () {
      if (this.styleOptions.length > 0) {
        this.showThis.styles = true
      } else {
        this.showThis.styles = false
      }
    },
    extrasOptions () {
      if (this.extrasOptions.length > 0) {
        this.showThis.extras = true
      } else {
        this.showThis.extras = false
      }
    },
    '$i18n.locale': {
      handler: function () {
        this.styleOptions = []
        this.extrasOptions = []
        this.buildVariant()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 600px) {
  .card-body {
    padding: 0.5rem;
  }
  .col {
    padding: 0;
  }
}
h5 > a {
  font-size: 0.9rem;
}

h5 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Variant.vue